import { Tag } from 'carbon-components-react';
import { OSAnswerType } from '../../Maas360Estimator';
import { TranslationFunction } from 'src/common/hooks/widgets/useTranslation';

type selectionProps = {
  state: string;
  answer?: string | number;
  arrAns?: OSAnswerType[];
  quesID?: string;
  useTranslation: TranslationFunction;
};

const Selection = ({
  state,
  answer,
  quesID,
  arrAns,
  useTranslation,
}: selectionProps) => {
  const getColor =
    quesID !== 'Q3A2' && quesID !== 'Q4A2' && quesID !== 'Q5A2'
      ? 'green'
      : 'red';
  const q3Ans =
    quesID === 'Q6A1'
      ? useTranslation('que6_opt1_short_ans_selec', true).toString()
      : quesID === 'Q6A2'
      ? useTranslation('que6_opt2_short_ans_selec', true).toString()
      : quesID === 'Q6A3'
      ? useTranslation('que6_opt3_short_ans_selec', true).toString()
      : null;
  return arrAns?.length ? (
    <li className="selection-item">
      <div className="margin">
        <span className="selection-state">{state}:</span>
        {arrAns?.map((item: { text: string }) => (
          <Tag
            type={'purple'}
            size="md"
            disabled={false}
            filter={false}
            style={{ marginLeft: '5px' }}
          >
            {item.text}
          </Tag>
        ))}
      </div>
    </li>
  ) : (
    <li className="selection-item">
      <div className="margin">
        <span className="selection-state">{state}:</span>
        <Tag
          type={
            quesID?.includes('Q3') ||
            quesID?.includes('Q4') ||
            quesID?.includes('Q5')
              ? getColor
              : 'purple'
          }
          size="md"
          disabled={false}
          filter={false}
          style={{ marginLeft: '5px' }}
        >
          {quesID?.includes('Q6') ? q3Ans : answer}
        </Tag>
      </div>
    </li>
  );
};

export default Selection;
